module.exports = __webpack_public_path__ + "static/media/laboratorios.c7dec77a.jpg";